import { Component, OnInit, Input } from '@angular/core';
import { Data, Router } from '@angular/router';
import { EventSendeurService } from '../../../shared/event-sendeur.service';
import { NbToastrService, NbDialogRef, NbDialogService } from '@nebular/theme';
import { MediathequeComponent } from '../../../shared/mediatheque/mediatheque.component';
import { DomSanitizer } from '@angular/platform-browser';

import {plainToClass} from 'class-transformer';
import { Img } from '../../../shared/data/img';
import { Config } from '../../../config/config';
import { NbIconLibraries } from '@nebular/theme';
import { ApiService } from '../../../shared/api.service';
import { Ecole } from '../../../shared/data/ecole';
import { Critere } from '../../../shared/data/critere';
import { PaysService } from '../../../shared/pays.service';
import { EditCritereComponent } from '../../criteres/edit-critere/edit-critere.component';
import { EditFormationComponent } from '../../formations/edit-formation/edit-formation.component';
import { Formation } from '../../../shared/data/formation';
import { Admission } from '../../../shared/data/admission';

@Component({
  selector: 'ngx-edit-admission',
  templateUrl: './edit-admission.component.html',
  styleUrls: ['./edit-admission.component.scss']
})
export class EditAdmissionComponent implements OnInit {
  @Input() id: number;
  @Input() ecole: number;
  @Input() facultes: any[];

  /* description;

  slug;
  titre;
  datePublish; */
  heure = "15";
  minute = "22";
  admission = new Admission;
  hideButon = false;
  hideLoader = true;
  //photoSelected: Img; 

  url: string

  config = Config;
  
  // isPublish = false;

  selectedItems = [];
  dropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'chemin',
    selectAllText: 'Selectionner tous',
    unSelectAllText: 'Déselectionner tout',
    itemsShowLimit: 10,
    allowSearchFilter: true,
    closeDropDownOnSelection: true,
  };

  formations: Formation[] = [];
  options: Critere[] = [];
  
  constructor(public paysService: PaysService, iconsLibrary: NbIconLibraries, private sanitizer: DomSanitizer,private dialogService: NbDialogService,protected dialogRef: NbDialogRef<EditAdmissionComponent>,private apiService:ApiService, private router:Router,private sendeurService:EventSendeurService, public toastr:NbToastrService ) { 
  
    this.url = Config.urlserveur;
    iconsLibrary.registerFontPack('fa', { packClass: 'fa', iconClassPrefix: 'fa' });
    iconsLibrary.registerFontPack('far', { packClass: 'far', iconClassPrefix: 'fa' });
    iconsLibrary.registerFontPack('ion', { iconClassPrefix: 'ion' });

    // this.model = this.ecole.converDatePublishToNgbDateStruct;

    // this.getEcole();


  
  }

  ngOnInit() {


    this.apiService.getAllCritereProvider('').subscribe(data =>{
     
      this.options = data;

    })

    
  
    if(this.id !== 0)
    this. getOneAdmission();
  

    this.sendeurService.critereEvent.subscribe( data => {

      console.log(data)
      
      const index = this.options.findIndex(elem => elem.id ===  data.id);

      if(index === -1 ) {

        this.options.push(data);

        if(data.type_critere === 'admissibility')
        this.admission.admissibilite = data.id;

        if(data.type_critere === 'cycle')
        this.admission.cycle = data.id;

        if(data.type_critere === 'niveau')
        this.admission.niveau_requis = data.id;

      }

    })


    this.sendeurService.formationEvent.subscribe( data => {

      console.log(data)
      
      const index = this.formations.findIndex(elem => elem.id === data.id);

      if(index === -1 ) {

        const row = {
            id: data.id,
            chemin: data.chemin
        }

        this.formations.push(data);

        // on force la mise à jour du composant
        const fors = JSON.parse(JSON.stringify(this.formations)); 

        this.formations = fors;



        this.selectedItems.push(row)

        // on force la mise à jour du composant
        const forsselect = JSON.parse(JSON.stringify(this.selectedItems));

        this.selectedItems = forsselect;
      
        /* if(this.ecole.formations === undefined)
        this.ecole.formations = []; */

        this.admission.formations.push(row);

        

      }

    })




    this.getFormations();

    

   
  }

  

  updateAdmission(){

      // return;

      this.hideButon = true;
      this.hideLoader = false;
    /* var data = JSON.parse(localStorage.getItem("image"));
    if(!JSON.parse(localStorage.getItem("image"))){
    
      this.toastr.danger(" vous devez choisir une image");
      this.hideButon = false;
      this.hideLoader = true;
      return false;
    } */
    


   
   if(this.id !== 0) {

    this.apiService.updateAdmissionProvider(this.admission).subscribe((data: Admission) =>{
      console.log(data);
      this.dialogRef.close();
      /* this.sendeurService.fichier.next(null); */
      this.toastr.success("mise à jour réussie","success");
      localStorage.removeItem("image");
      this.sendeurService.sendAdmissionEvent(data); 
    },(err) =>{
      console.log(err);
      this.toastr.danger(" echec de mise à jour , remplissez tous les champs ")
      this.hideButon = false;
      this.hideLoader = true;
      if(err.error.code ===401){
       localStorage.clear();
       window.location.reload();
       let link2 = ['/login'];
       this.router.navigate(link2);
     }
 
     if(err.error.code ===500){
        this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");
     }
     
    })

   } else {

    this.apiService.addAdmissionProvider(this.ecole, this.admission).subscribe((data: Ecole) =>{
      console.log(data);
      this.dialogRef.close();
      this.toastr.success("admission crée avec success", "success");
      /* localStorage.removeItem("fichier"); */
      /* this.sendeurService.fichier.next(null);*/
      this.sendeurService.sendAdmissionEvent(data); 
    },(err) =>{

     this.hideButon = false;
     this.toastr.danger("il se peut qu'une admission porte déjà le meme nom", "erreur")
      console.log(err);
      if(err.error.code ===401){
       localStorage.clear();
       window.location.reload();
       let link2 = ['/login'];
       this.router.navigate(link2);
     }
 
     if(err.error.code ===500){
      this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");
     }
  
    })

   }
   
  }



  


  getOneAdmission(){
    this.apiService.getOneAdmissionProvider(this.id).subscribe((data: Admission) =>{

      this.admission = plainToClass(Admission, data as object);
      
      this.selectedItems = data.formations;

      console.log(this.selectedItems);
      // console.log(this.page.converDatePublishToNgbDateStruct);
      
    },(err) =>{
      if(err.error.code ===401){
        localStorage.clear();
        window.location.reload();
        let link2 = ['/login'];
        this.router.navigate(link2);
      }

      if(err.error.code ===500){
      
        this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");
     }
    })
  }


  cancel(){
    this.dialogRef.close();
    this.sendeurService.fichier.next(null);
  }

  close(){
    this.dialogRef.close();
    this.sendeurService.fichier.next(null);
  }

  onItemSelect(item: any) {

    //this.target = item.id.toString();

    if( this.admission.formations !== null && this.admission.formations !== undefined)
    this.admission.formations.push(item);
    else {
      this.admission.formations = [];
      this.admission.formations.push(item);
    }

    // console.log(this.admission.formations);
    // this.page.parent_page = item
   
  }

  
  onItemDeSelect(item: any){
    // this.target = '';
    // this.page.parent_page = null
    const index = this.admission.formations.findIndex(elem => elem.id === item.id);
    if(index !== -1)
    this.admission.formations.splice(index, 1);

    console.log(this.admission.formations);

  }

  onSelectAll(items: any) {
    this.admission.formations = items;
    console.log(this.admission.formations);
  }

  onDeSelectAll($event){
    this.admission.formations = [];
    console.log(this.admission.formations);
  }

  onUnSelectAll(){
    
  }

  onDropDownClose($event){
    
  }

  getFormations(){

    this.apiService.getAllformationProvider('').subscribe(data =>{
      
      this.formations = data;

    })
  
  }


  addCondition() {
    this.dialogService.open(EditCritereComponent,{context:{id:0, typecrit:'admissibility'}});
  }

  addCycle() {
    this.dialogService.open(EditCritereComponent,{context:{id:0, typecrit:'cycle'}});
  }

  addFormation() {
    this.dialogService.open(EditFormationComponent,{context:{id:0}});
  }


  addNiveau() {
    this.dialogService.open(EditCritereComponent,{context:{id:0, typecrit:'niveau'}});
  }


  addDateRentree() {
    this.dialogService.open(EditCritereComponent,{context:{id:0, typecrit:'daterentree'}});
  }


}
